import styled from 'styled-components';

export const ButtonContainer = styled.button` 
    padding: 20px;
    border: 2px solid black;
    background-color: gray;
    color: #FFFFFF;
    font-size: 24px;
    font-weight: 700;
    flex: 1;

    &:hover {
        opacity: 0.6;
    }
`